import { Component, OnInit } from '@angular/core';
import { IDictionary } from 'src/app/interfaces/dictionary';
import { DictionaryService } from 'src/app/services/dictionary.service';
import {Response} from "../../interfaces/response";
import { SpinnerService } from 'src/app/services/spinner.service';
//import {FlashMessagesService} from 'angular2-flash-messages';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';




@Component({
  selector: 'app-dictionary',
  templateUrl: './dictionary.component.html',
  styleUrls: ['./dictionary.component.scss']
})
export class DictionaryComponent implements OnInit {

  dictionarys: IDictionary[];
  lastPage: number;
  search: string;
  percentage: number;
  errorMsg: string;
  total: number;

  constructor(
    private dictionaryService: DictionaryService,
    public spinnerService: SpinnerService
    //public flashMensaje: FlashMessagesService
    ){ }

  ngOnInit() {
    this.spinnerService.on();
    this.refresh();
  }

  refresh(currentPage = 1, search= '', percentage= 0) {
    this.spinnerService.on();
    this.dictionaryService.all(currentPage, search, percentage).
      subscribe(
        (res: Response) => {

      if (res.data){
         this.dictionarys = res.data;

         this.lastPage = res.meta.last_page;
        // this.flashMensaje.show('Existen Datos.', {cssClass: 'alert-success', timeout: 4000});
      } else{
        //  this.flashMensaje.show('Existen sin resultados .', {cssClass: 'alert-warning ', timeout: 4000});
      }

        this.spinnerService.off();
        },
        error =>
          { //console.log('oops', error)
             this.spinnerService.off();
         //    this.flashMensaje.show('Error.', {cssClass: 'alert-danger', timeout: 4000});
          }
      )
  }

  delete(id: number) {
    if (confirm('Are you sure you want to delete this record?')) {
      this.dictionaryService.delete(id).subscribe(
        res => {
          this.dictionarys = this.dictionarys.filter(el => el.id !== id);
        }
      );
    }
  }







}
